import request from '@/utils/request'; // 战斗力排行

export function szGetFightingRank(data) {
  return request({
    url: '/data/szGetFightingRank',
    method: 'get',
    params: data
  });
}